<template>
  <nav>
    <v-app-bar dark
               app
               color="primary">
      <v-app-bar-nav-icon v-if="isSmall" @click="toggleNavigation"/>

      <img class="header-logo ml-2" src="../../assets/logo-branca.png"
           alt="Logo da Proxpect"/>

      <v-spacer/>

      <px-notificacoes/>
      <px-carrinho/>
      <px-user-info/>
    </v-app-bar>

    <px-naviagtion v-model="navigationOpened" />
  </nav>
</template>

<script>
import Navigation from '../navigation/Navigation.vue';

export default {
  data() {
    return {
      navigationOpened: false,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    toggleNavigation() {
      this.navigationOpened = !this.navigationOpened;
    },
    changeNavigation(value) {
      if (this.navigationOpened !== value) {
        this.navigationOpened = value;
      }
    },
  },
  components: {
    pxNaviagtion: Navigation,
  },
};
</script>

<style scoped>
  .header-logo {
    width: 180px;
  }
</style>
